import { createGeminiImage, fileToBase64, isGeminiAvailable } from './gemini-client.js';

const form = document.querySelector('form[data-sketch-form]');
const fileInput = document.querySelector('#sketch-photo');
const fileLabel = document.querySelector('[data-file-label]');
const styleSelect = document.querySelector('#sketch-style');
const statusEl = document.querySelector('[data-status]');
const originalFrame = document.querySelector('[data-original-img]');
const previewFrame = document.querySelector('[data-result-img]');
const downloadBtn = document.querySelector('[data-download]');
const submitBtn = form?.querySelector('button[type="submit"]');
let originalObjectUrl = null;
let geminiReady = true;

const STYLE_PROMPTS = {
  watercolor:
    'Transform the rabbit into a hand-painted watercolor illustration on textured paper. keep gentle brush strokes, warm pastel palette, soft shadowing.',
  pencil: 'Convert the rabbit into a clean graphite pencil sketch with cross-hatching, high contrast, museum study sheet aesthetic.',
  gouache:
    'Render the rabbit as a gouache-style poster with bold outlines, limited palette, vintage japanese children book mood.'
};

function setStatus(message, isError = false) {
  statusEl.textContent = message;
  statusEl.classList.toggle('error', isError);
}

function updateOriginalPreview(file) {
  if (originalObjectUrl) {
    URL.revokeObjectURL(originalObjectUrl);
    originalObjectUrl = null;
  }

  if (!file) {
    originalFrame.style.backgroundImage = '';
    originalFrame.classList.add('placeholder');
    return;
  }

  originalObjectUrl = URL.createObjectURL(file);
  originalFrame.style.backgroundImage = `url(${originalObjectUrl})`;
  originalFrame.classList.remove('placeholder');
}

function setResult(base64) {
  if (!base64) {
    previewFrame.style.backgroundImage = '';
    previewFrame.classList.add('placeholder');
    downloadBtn.classList.add('is-hidden');
    return;
  }
  const dataUrl = `data:image/png;base64,${base64}`;
  previewFrame.style.backgroundImage = `url(${dataUrl})`;
  previewFrame.classList.remove('placeholder');
  downloadBtn.href = dataUrl;
  downloadBtn.download = 'croissant-sketch.png';
  downloadBtn.classList.remove('is-hidden');
}

async function initGeminiAvailability() {
  if (!form || !statusEl) return;
  geminiReady = await isGeminiAvailable();
  if (!geminiReady) {
    submitBtn?.setAttribute('disabled', 'true');
    setStatus('Image generation is offline right now. Tools are in preview mode.');
    form.classList.add('tool-disabled');
  }
}

fileInput.addEventListener('change', () => {
  const file = fileInput.files?.[0];
  if (fileLabel) {
    fileLabel.textContent = file ? file.name : 'No file selected';
  }
  updateOriginalPreview(file || null);
});

form.addEventListener('submit', async (event) => {
  event.preventDefault();
  if (!geminiReady) {
    setStatus('Image generation is offline. Please check back soon.', true);
    return;
  }
  const file = fileInput.files?.[0];
  if (!file) {
    setStatus('Please upload a clear rabbit photo first.', true);
    return;
  }
  if (file.size > 6 * 1024 * 1024) {
    setStatus('Image exceeds 6MB. Please compress and re-upload.', true);
    return;
  }

  const style = styleSelect.value;
  const prompt = `${STYLE_PROMPTS[style]} Preserve the rabbit's pose and proportions.`;

  try {
    setStatus('Generating illustration—this takes about 10-15 seconds…');
    setResult('');
    const { base64, mimeType } = await fileToBase64(file);
    const output = await createGeminiImage({
      prompt,
      base64Image: base64,
      mimeType
    });
    setResult(output);
    setStatus('Sketch ready! Download the PNG below.');
  } catch (error) {
    console.error(error);
    setStatus(error.message || 'Generation failed. Please try again.', true);
    setResult('');
  }
});

initGeminiAvailability();
